import helpers from "@kinetics254/cassandra-base/utilities/helpers/helper";
export default {
  methods: {
    /**
     * Check document type condition
     */
    checkRequisitionType(documentType, requisitionType) {
      if (documentType === requisitionType.purchaseRequisition) {
        requisitionType.isPurchaseRequisition = true;
      } else if (documentType === requisitionType.userRequisition) {
        requisitionType.isUserRequisition = true;
      } else if (documentType === requisitionType.storeRequisition) {
        requisitionType.isStoreRequisition = true;
      }
    },
    /**
     * Color codes
     * @param status
     * @returns {*}
     */
    getStatusColor: function (status) {
      return helpers.getColor(status);
    },
    /**
     * Remove an attachment
     * @param index
     */
    deleteAttachment(index) {
      this.formData.attachments.splice(index, 1);
    },
    /**
     * Send cancel request to the server
     */
    cancelRequisition(item) {
      if (this.$route.query.code) {
        this.$store.dispatch("Requisition/sendCancelRequest", {
          headerNo: this.$route.query.code,
        });
      } else {
        this.$store.dispatch("Requisition/sendCancelRequest", {
          headerNo: item.no,
        });
      }
    },
    /**
     * Save and send the requisition for approval
     */
    sendApprovalRequest(method) {
      if (this.$refs.requisitionForm.validate() && this.isView) {
        this.$confirm.show({
          text: "Are you sure you want to send this requisition for approval?",
          onConfirm: () => {
            delete this.formData.amount;
            delete this.formData.amountLCY;
            delete this.formData.amountIncludingVAT;
            delete this.formData.vatAmount;
            if (this.attachmentBase64.length !== 0) {
              Array.prototype.push.apply(
                this.formData.attachments,
                this.attachmentBase64
              );
            }

            this.$store.dispatch("Requisition/saveAndSendForpproval", {
              ...this.formData,
              method,
            });
          },
        });
      } else if (this.$refs.requisitionForm.validate() && !this.isView) {
        this.$confirm.show({
          text: "Are you sure you want to send this requisition for approval?",
          onConfirm: () => {
            this.formData.documentType = this.documentType;
            this.formData.requestedBy = this.employee.number;
            delete this.formData.no;
            delete this.formData.headerNo;
            this.formData.attachments = this.attachmentBase64;
            this.$store.dispatch("Requisition/saveAndSendForpproval", {
              ...this.formData,
              method,
            });
          },
        });
      } else {
        this.$refs.requisitionForm.validate();
      }
    },
    sendListApprovalRequest(val) {
      this.$confirm.show({
        title: `Requisition No:  ${val}`,
        text: "Are you sure you want to send this requisition for approval?",
        onConfirm: () => {
          this.$store.dispatch("Requisition/sendApprovalRequest", {
            headerNo: val,
          });
          // eslint-disable-next-line no-unused-expressions
        },
      });
    },
    /**
     * This method
     * @param data
     */
    deleteRequisition: function (data) {
      this.$confirm.show({
        title: this.$route.params.documentType
          ? `Requisition No:  ${data.no}`
          : "",
        text: "Are you sure you want to delete this requisition?",
        onConfirm: () => {
          this.$store.dispatch("Requisition/deleteRequisition", { data });
          // eslint-disable-next-line no-unused-expressions
          this.$route.query.code ? Event.$emit("back") : null;
        },
      });
    },
    /**
     * Get date format
     * @param date
     * @returns {string|*}
     */
    getDateFormat: function (date) {
      return helpers.shortDateFormat(date);
    },
    getFileBlob: async function (url, fileName) {
      return await helpers.getFileBlob(
        process.env.VUE_APP_FILE_API + url,
        fileName
      );
    },
  },
  computed: {
    dimension1() {
      return this.dimensionValues.filter(
        (item) =>
          item.globalDimensionNo === 1 && item.dimensionValueType === "Standard"
      );
    },
    dimension2() {
      return this.dimensionValues.filter(
        (item) =>
          item.globalDimensionNo === 2 && item.dimensionValueType === "Standard"
      );
    },
    dimension3() {
      return this.dimensionValues.filter(
        (item) =>
          item.globalDimensionNo === 3 && item.dimensionValueType === "Standard"
      );
    },
    dimension4() {
      return this.dimensionValues.filter(
        (item) =>
          item.globalDimensionNo === 4 && item.dimensionValueType === "Standard"
      );
    },
    dimension5() {
      return this.dimensionValues.filter(
        (item) =>
          item.globalDimensionNo === 5 && item.dimensionValueType === "Standard"
      );
    },
    dimension6() {
      return this.dimensionValues.filter(
        (item) =>
          item.globalDimensionNo === 6 && item.dimensionValueType === "Standard"
      );
    },
    dimension7() {
      return this.dimensionValues.filter(
        (item) =>
          item.globalDimensionNo === 7 && item.dimensionValueType === "Standard"
      );
    },
    dimension8() {
      return this.dimensionValues.filter(
        (item) =>
          item.globalDimensionNo === 8 && item.dimensionValueType === "Standard"
      );
    },
    funds() {
      return this.$store.getters["imprest/imprestGetters"]("funds");
    },
    speedKeys() {
      return this.$store.getters["imprest/imprestGetters"]("speedKeys");
    },
  },
};
